<script setup>
import { useSmallScreen } from '../composables/useSmallScreen.js';
import { useOffice } from '../i18n/office.js';

const { to } = useOffice();

/* Полоса «телефон — только просмотр».

   Без неё режим чтения выглядит как поломка: человек ищет кнопку, которой
   нет, и решает, что система не загрузилась. Молча спрятанная кнопка —
   худший вид отказа, потому что он не называет ни причины, ни выхода.

   Полоса говорит и то и другое: почему нельзя и где можно.

   Текст общий для всех экранов. Полоса стоит в оболочке приложения
   (App.vue), а не на цеховых экранах, и прежние слова про выпуск и смену
   на заказах и в настройке звучали про чужое. */

const { толькоЧтение } = useSmallScreen();
</script>

<template>
  <div v-if="толькоЧтение" class="ro-bar">
    <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor"
         stroke-width="1.8" stroke-linecap="round" aria-hidden="true">
      <path d="M2 12s3.6-6.5 10-6.5S22 12 22 12s-3.6 6.5-10 6.5S2 12 2 12z" />
      <circle cx="12" cy="12" r="2.6" />
    </svg>
    <span>
      <strong>{{ to('Телефон — только просмотр.') }}</strong>
      {{ to('Смотреть можно всё, что доступно вашей роли. Изменения делаются с планшета или компьютера — на ходу с телефона легко нажать не ту кнопку.') }}
    </span>
  </div>
</template>

<style scoped>
.ro-bar {
  display: flex; align-items: flex-start; gap: 10px;
  padding: 10px 14px; border-radius: var(--r-md);
  border: 1px solid var(--st-idle);
  background: color-mix(in srgb, var(--st-idle) 10%, transparent);
  color: var(--t1); font-size: var(--fs-small); line-height: 1.4;
}
.ro-bar svg { flex: none; margin-top: 2px; color: var(--st-idle); }
</style>
